import { gql } from '@apollo/client'
import { useMutation } from 'src/services/apollo'
import { IUseMutationOptions } from 'src/services/apollo/Mutation/useMutation'
import {
  QualificationInstanceAttachmentCreate,
  QualificationInstanceAttachmentCreateVariables,
} from './__gql__/qualificationInstanceAttachmentCreateCodeGen'

const QUALIFICATION_INSTANCE_ATTACHMENT_CREATE = gql`
  mutation QualificationInstanceAttachmentCreate(
    $qualificationInstanceId: ID!
    $filename: String!
    $mime: String!
    $size: Int!
    $extension: String!
  ) {
    qualificationInstanceAttachmentCreate(
      input: {
        qualificationInstanceId: $qualificationInstanceId
        filename: $filename
        mime: $mime
        size: $size
        extension: $extension
      }
    ) {
      presignedUploadUrl
      document {
        id
        createdAt
        createdAtTimestamp: createdAtDateTime
        createdAtDateTime
        displayName
        downloadUrlAbsolute
        humanReadableSize
        extension
        uploadStatus
        size
        personId
        downloadUrl
        category
      }
    }
  }
`

const useQualificationInstanceAttachmentCreate = (
  options?: IUseMutationOptions<QualificationInstanceAttachmentCreate, QualificationInstanceAttachmentCreateVariables>,
) => {
  return useMutation<QualificationInstanceAttachmentCreate, QualificationInstanceAttachmentCreateVariables>(
    QUALIFICATION_INSTANCE_ATTACHMENT_CREATE,
    {
      ...options,
    },
  )
}

export { useQualificationInstanceAttachmentCreate }
